define('SuggestedFoodPairing.View', [
    'suggestedfoodpairing.tpl',
    'Backbone',
    'jQuery',
    'underscore',
    'SC.Configuration',
    'Utils',
    'Backbone.View'
], function SuggestedFoodPairingView(
    suggestedFoodPairingTpl,
    Backbone,
    jQuery,
    _,
    Configuration,
    Utils,
    BackboneView
) {
    'use strict';

    return Backbone.View.extend({
        contextDataRequest: ['item'],
        template: suggestedFoodPairingTpl,
        initialize: function initialize(options) {
            this.config = options.config;
        },
        getItem: function getItem() {
            return this.contextData.item();
        },
        createSuggestedItemsModal: function createSuggestedItemsModal() {
            var view = new SuggestedFoodPairingSuggestedView({
                application: this.options.application,
                collection: this.suggestedCollection
            });
            if (this.suggestedCollection.length) {
                return this.options.application.getLayout().showInModal(view);
            }
            this.showNotFoundInModal(Configuration.get('SuggestedFoodPairing.noItemsTitle'), Configuration.get('SuggestedFoodPairing.noItemsMessage'));

            return null;
        },
        showNotFoundInModal: function showNotFoundInModal(title, message) {
            var view = new BackboneView({ application: this.application });

            view.title = Utils.translate(title);
            view.render = function renderFn() {
                this.$el.append('<p class="error-message">' + message + '</p>');
            };
            return this.options.application.getLayout().showInModal(view);
        },
        showSuggestedItems: function showSuggestedItems(e) {
            var self = this;
            var label = jQuery(e.target).prop('tagName') === 'DIV' ? jQuery(e.target).find('img').data('label') : jQuery(e.target).data('label');
            this.suggestedCollection = new SuggestedFoodPairingCollection();
            this.suggestedCollection.fetch({
                data: {
                    query: label
                }
            }).done(function dnFn() {
            });
        },
        getContext: function getContext() {
            var item = this.getItem();
            var pairsWellWith = (item && item.custitem_aws_pairs_well_with) ? item.custitem_aws_pairs_well_with : '';
            var assetsPath = (this.config && this.config.assetsPath) ? this.config.assetsPath : '/assets/food-icons/';
            var imageExtension = (this.config && this.config.iconExtension) ? '.' + this.config.iconExtension : '.svg';
            var ClickMessage = this.config.clickIconsMessage;
            var pairsImages = [];
            var imageLabel;

            pairsWellWith = (pairsWellWith === '&nbsp;') ? '' : pairsWellWith;
            pairsWellWith = pairsWellWith.split(',');
            pairsWellWith = _.map(pairsWellWith, function map(value) {
                return jQuery.trim(value);
            });
            pairsWellWith = _.compact(pairsWellWith);

            if (pairsWellWith && pairsWellWith.length) {
                _.each(pairsWellWith, function each(option) {
                    imageLabel = option;
                    if (imageLabel.indexOf('/') !== -1) {
                        imageLabel = imageLabel.split('/').join('-');
                    }
                    pairsImages.push({
                        label: imageLabel,
                        realLabel: option,
                        url: assetsPath + imageLabel.toLowerCase() + imageExtension
                    });
                });
            }
            return {
                pairsImages: pairsImages,
                showSuggestedFood: !!(pairsImages && pairsImages.length),
                ClickMessage: ClickMessage
            };
        }
    });
});
